import Badges from './Badges.vue';
export default Badges;


// WEBPACK FOOTER //
// ./src/components/parts/slider/badges/index.ts